import BackButtonRow from "../../../Common/DetailsForm/Fragments/BackButtonRow";
import EditButton from "../../../Common/DetailsForm/Fragments/EditButton";

import { httpGet } from "../../../Common/Http/httpGet";
import LoadingContentWrapper from "../../../Common/Loading/LoadingContentWrapper";
import { useEffect, useState } from "react";
import DetailsPresenter from "./DetailsPresenter";
import { viewModel } from "./viewModel";
import LinkButtonWithIcon from "../../../Common/DetailsForm/Fragments/LinkButtonWithIcon";

export default function Details(props: {
  navigate: (url: string) => void;
  backUrl?: string;
}) {
  let backUrl = props.backUrl || "/";

  const [dataObject, setDataObject] =
    useState<viewModel | undefined>(undefined);

  useEffect(() => {
    const setData = async () => {
      setDataObject(undefined);
      let a = await httpGet<viewModel>("/api/Consent/EInvoiceConsent/GetState");
      setDataObject(a);
    };

    setData();
  }, []);

  return (
    <>
      <h1 className="border-bottom pb-2 mt-4 mb-4">E-faktury</h1>
      <LoadingContentWrapper isLoading={!dataObject}>
        {!!dataObject && (
          <>
            <div className="mb-2" style={{ marginTop: "-8px" }}>
              <EditButton
                onClick={() => {
                  props.navigate("./../Edit?backUrl=../index");
                }}
                text="Zmień"
              />
              <LinkButtonWithIcon
                href="./history"
                buttonText="Historia zmian"
                buttonClass="btn-primary"
                icon={<i className="bi bi-list-ul"></i>}
              />
            </div>

            <div
              className="alert alert-primary d-flex align-items-center mt-3"
              role="alert"
            >
              <div className="flex-shrink-0 ms-3 me-4">
                <i className="bi bi-lightbulb"></i>
              </div>
              <div>
                <b>Uwaga:</b> jeśli adresy do e-faktur zostały zmienione w ciągu
                ostatniej godziny, przedstawione dane mogą być nieaktualne.
                Prosimy o ponowną weryfikację za kilka godzin.
              </div>
            </div>

            <DetailsPresenter object={dataObject!}></DetailsPresenter>
            <BackButtonRow
              onClick={() => {
                props.navigate(backUrl);
              }}
            />
          </>
        )}
      </LoadingContentWrapper>
    </>
  );
}
